export module CustomGridFilterModule{
    export function onFilterMenuInit(e) {
    
        e.container.find("select:eq(1)").data("kendoDropDownList").value("or");
        if (e.field!==undefined){
            initCheckboxFilter.call(this, e);
        }
    }

    function initCheckboxFilter(e) {


        let popup = e.container.data("kendoPopup");
        let dataSource = this.dataSource;
        let field = e.field;
        let checkboxesDataSource = new kendo.data.DataSource({
            data: uniqueForField(dataSource.data(), field),
            sort: { field: field, dir: "asc" },
            change: selectAllCheckboxFilter
        });
        e.container.find("input.k-textbox").remove();

        let firstFilterDropdown = e.container.find(".k-widget.k-dropdown:eq(0)");
        let secondFilterDropdown = e.container.find(".k-widget.k-dropdown:eq(2)");

        let firstInput;
        let secondInput;

        var kgrid = $("#"+ e.sender.element[0].id).data("kendoGrid");
        var fieldType = kgrid.dataSource.options.schema.model.fields[e.field].type;

        switch(fieldType) {
            case "string":
                e.container.find('[data-bind="value: filters[0].operator"]').data('kendoDropDownList').value("startswith");
                firstInput  =  $("<input class='k-textbox firstFilter' type='search'/>").insertAfter(firstFilterDropdown);
                secondInput =   $("<input class='k-textbox secondFilter' type='search' />").insertAfter(secondFilterDropdown);
                break;
            case "number":
                firstInput =  $(".firstFilter").kendoNumericTextBox({
                    decimals: 2
                });
                secondInput = $(".secondFilter").kendoNumericTextBox({
                    decimals: 2
                });
                break;
           case "date":
                e.container.find('[data-bind="value: filters[0].operator"]').data('kendoDropDownList').value("eq");
                firstInput = $(".firstFilterDatepicker").kendoDatePicker({
                   format: "dd.MM.yyyy."
                });
                secondInput = $(".secondFilterDatepicker").kendoDatePicker({
                    format: "dd.MM.yyyy."
                 });
                break; 
            default:
                firstInput =  $("<input class='k-textbox firstFilter' type='search'/>").insertAfter(firstFilterDropdown);
                secondInput =   $("<input class='k-textbox secondFilter' type='search' />").insertAfter(secondFilterDropdown);
                break;
        }


        let helpTextElement = e.container.children(":first").children(":first");
       // helpTextElement.nextUntil(":has(.k-button)").remove();
        let selectAllCheckbox = $("<div class='k-item'><input type='checkbox' class='selectAllFilter k-item' /> Select All <button class='close'>x</button></div>").insertBefore(e.container.find(".k-filter-help-text"));
        let element = $("<div class='checkbox-container'></div>").insertAfter(helpTextElement).kendoListView({
            dataSource: checkboxesDataSource,
            template: kendo.template("<div class='checkboxContent k-item'><input type='checkbox' class='colDefFilter k-item' value='#:" + field + "#'  /> #: (" + field + "!==null) ? kendo.toString(" + field + ", 'dd.MM.yyyy') : '' #</div>")
        });

      var filterList = {
        logic: "or",
        filters:[]
    }

      $(".firstFilter").on("input", function () {

        var sarchString = $(this).val();
        var dataSourceCb = checkboxesDataSource;

         if(filterList.filters.length > 0){
            filterList = {
                logic: "or",
                filters:[]
            }
         }
        filterList.filters.push({ field: e.field, operator: e.container.find("select:eq(0)").data("kendoDropDownList").value(), value: sarchString });
        dataSourceCb.filter(filterList);
    });

    $(".secondFilter").on("input", function () {
        var sarchString = $(this).val();
        if( $(".firstFilter").val() == undefined || $(".firstFilter").val() == "" ){
            filterList = {
                logic: "or",
                filters:[]
            }
         }else{
           //TODO:see the logic here - check if needed 
         }

        var dataSourceCb = checkboxesDataSource;
        filterList.filters.push({ field: e.field, operator: e.container.find("select:eq(2)").data("kendoDropDownList").value(), value: sarchString });
        dataSourceCb.filter(filterList);
 
    });

    $("input[data-role='datepicker']").on("input", function () {
        var sarchString = $(this).val();
        var dataSourceCb = checkboxesDataSource;
       
         if(filterList.filters.length > 0) {
            filterList = {
                logic: "or",
                filters:[]
            }
        }else{
            filterList.filters.push({ field: e.field, operator: e.container.find("select:eq(0)").data("kendoDropDownList").value(), value: new Date(sarchString.split('.').reverse().join('.')) });
       }
        dataSourceCb.filter(filterList);
    });


        e.container.find("[type='submit']").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            let filter = dataSource.filter() || { logic: "and", filters: [] };
            let fieldFilters = $.map(element.find(":checkbox:checked"), function (input) {
                return {
                    field: field,
                    operator: "eq",
                    value: input.value
                };
            });
            if (fieldFilters.length) {
                removeFiltersForField(filter, field);
                filter.filters.push({
                    logic: "or",
                    filters: fieldFilters
                });
                dataSource.filter(filter);

            }
            $("#closeGridFilter").click(popup.close());
            popup.close();
        });

        // Hookup the Clear button event
        e.container.find("[type='reset']").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            // clear whatever have been checked in the checkbox list to the grid
            let filter = dataSource.filter() || { logic: "and", filters: [] };
            let fieldFilters = $.map($(element).find(":checkbox:checked"), function (input) {
                return {
                    field: field,
                    operator: "eq",
                    value: input.value
                };
            });

            if (fieldFilters.length) {
                removeFiltersForField(filter, field);
                dataSource.filter(filter);
                $(this).closest('.k-filter-menu').find(".selectAllFilter").prop("checked", true);
                $(this).closest('.k-filter-menu').find(".colDefFilter").prop("checked", true);
            }
            popup.close();
        });

        $(e.container.find(".k-filter-help-text")).css("display", "none");
        let listBox = e.container.find(".checkbox-container");
        $("<br/><div>Show rows with value that</div>").insertAfter(listBox)

        filterItemClick();
    }


    function selectAllCheckboxFilter() {
        $(".selectAllFilter").click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.k-filter-menu').find(".colDefFilter").prop("checked", true);

            } else {
                $(this).closest('.k-filter-menu').find(".colDefFilter").prop("checked", false);
            }
        });
    }

    function filterItemClick() {
        $('.colDefFilter').on('click', function () {
            if ($('.colDefFilter:checked').length == $('.colDefFilter').length) {
                $('.selectAllFilter').prop('checked', true);
            } else {
                $('.selectAllFilter').prop('checked', false);
            }
        });
    }

    function uniqueForField(data, field) {
        let map = {};
        let result = [];
        let item;
        for (let i = 0; i < data.length; i++) {
            item = data[i];
            if (!map[item[field]]) {
                result.push(item.toJSON());
                map[item[field]] = true;
            }
        }
        return result;
    }

    function removeFiltersForField(expression, field) {
        if (expression.filters) {
            expression.filters = $.grep(expression.filters, function (filter: { filters: any, field: any }) {
                removeFiltersForField(filter, field);
                if (filter.filters) {
                    return filter.filters.length;
                } else {
                    return filter.field != field;
                }
            });
        }
    }


}


// WEBPACK FOOTER //
// ./app/insa-custom-scripts/customGrid-filter.ts